import { h } from 'preact';
import PropTypes from 'prop-types';

import { IconPlay, IconPause } from '../../1-foundation/icons/icons';

const PlayPause = ({ onClick, isPlaying }) =>
  !isPlaying ? (
    <IconPlay role="button" aria-label="Play" classNames="icon--audio" onClick={onClick} />
  ) : (
    <IconPause role="button" aria-label="Pausa" classNames="icon--audio" onClick={onClick} />
  );

PlayPause.propTypes = {
  isPlaying: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default PlayPause;
